import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { ToasterService } from 'angular2-toaster';
import { IMyDrpOptions } from "mydaterangepicker";
import * as moment from 'moment';
import * as _ from 'underscore';
@Component({
  selector: 'app-activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.css']
})
export class ActivityLogComponent implements OnInit {
  activityLogForm: FormGroup;
  searchQueryControl: FormControl = new FormControl('');
  companyControl: FormControl = new FormControl('');
  searchControl: FormControl = new FormControl('');
  shiftCreationDate:any=[];
  logCreationDate:any=[];
  companies:any =[];
  displayData:any=[];
  sites:any =[];
  disableSite:boolean = false;
  countTrue:any=[];
  showbtn:boolean =false;
  dummySites:any=[];
  showDrop:boolean=false;
  selectedCompanyName:string='';
  filteredCompanies: any = [];
  dummyCompany:any=[];
  logType:any=[];
  disableSiteforLog:any=['UPDATE_OVERTIME_SETTINGS', 'UPDATE_BREAK_SETTINGS', 'UPDATE_WEEKENDDAYS_SETTINGS','UPDATE_COMPANY_SETTINGS','ADD_BILL_OR_PAY_RATES',
   'UPDATE_BILL_OR_PAY_RATES','UPDATE_STAFF_PAY_RATES', 'SITE_LOG_DELETE', 'ARCHIVE_STAFF', 'DISABLE_STAFF', 'DELETE_STAFF', 'DELETE_LOG']
  
  public shiftDateRangePickerOptions: IMyDrpOptions = {
    dateFormat: 'dd mmm, yyyy'
  };
  public logDateRangePickerOptions: IMyDrpOptions = {
    dateFormat: 'dd mmm, yyyy'
  };

  constructor(
    private apiService: ApiService,
    private fb: FormBuilder,
    private toasterService: ToasterService
  ) {
    // this.filterSites = _.debounce(this.filterSites, 1000);
    this.filtercompany = _.debounce(this.filtercompany, 1000);
  }

  ngOnInit(): void {
    this.activityLogForm = this.fb.group({
      company: this.companyControl,
      logType: [''],
      sites: new FormArray([]),
      shiftDate: [''],
      logDate: ['']
    });

    this.activityLogForm.get('company').valueChanges.subscribe(selectedCompanyId => {
      if(!!selectedCompanyId){
         this.activityLogSites(selectedCompanyId);
      }
    });
    this.activityLogForm.get('logType').valueChanges.subscribe(selectedLogType => {
      if(this.disableSiteforLog.includes(selectedLogType)){
          this.disableSite = false;
      } else{ 
          this.disableSite = true;
      }
    });
    this.activityLogForm.get('sites').valueChanges.subscribe(selectedLogType => {
      this.countTrue = selectedLogType.filter(item => item === true).length;
    });

   this.getAllComapmies();
   this.getAllActivityLogsType();
  }

  get selectedSitesArray():any {
    return this.activityLogForm.controls.sites as FormArray ;
  }

  activityLogSites(event?){
    while (this.selectedSitesArray.length !== 0) {
      this.selectedSitesArray.removeAt(0);
    }
    let params:any={
      companyId:event
    };
    this.apiService.activityLogSites(params).subscribe((data:any) => {
			this.sites = data.data;
      // this.dummySites= data.data
      // this.filterSites();
      this.sites.forEach(() =>{
      this.selectedSitesArray.push(new FormControl(false));
		  },
		  error => {			
			  if(error.statusText ==  "Unauthorized") {
				window.open("/logout", "_self");
			  } else
			   this.toasterService.pop('error', error.error.message);
		  });
    })
  }

  getAllComapmies(){
    let params:any = {
			skip: 0,
			limit: 1000,
      name:''
		}
		this.apiService.getAllCompanies(params).subscribe((data:any) => {
    this.companies = data.data.companyData;
    this.dummyCompany = data.data.companyData
  },
  error => {			
    if(error.statusText ==  "Unauthorized") {
      window.open("/logout", "_self");
    } else
     this.toasterService.pop('error', error.error.message);
  });
  }

  getAllActivityLogsType()
  {
    this.apiService.activityLogsTypes().subscribe((data:any)=>{
      this.logType=data.data;
    },
    error => {			
      if(error.statusText ==  "Unauthorized") {
        window.open("/logout", "_self");
      } else
       this.toasterService.pop('error', error.error.message);
    })
  }

  selectCompany(selectedCompany: any) {
    this.selectedCompanyName=selectedCompany.name
    this.companyControl.setValue(selectedCompany._id);
    this.showDrop = false;
  }

  filtercompany(){
    const searchQuery = this.searchControl.value.toLowerCase().trim();
    if(searchQuery.length > 0){
      this.companies = this.companies.filter(company =>company.name.toLowerCase().trim().includes(searchQuery));
    } else{
      this.companies = this.dummyCompany;
    }
  }

  // filterSites() {
  //   const searchQuery = this.searchQueryControl.value.toLowerCase().trim();
  //   if(searchQuery.length > 0){
  //     while (this.selectedSitesArray.length !== 0) {
  //       this.selectedSitesArray.removeAt(0);
  //     }
  //     this.sites = this.sites.filter(site => site.title.toLowerCase().trim().includes(searchQuery));
  //     this.sites.forEach(() => {
  //       this.selectedSitesArray.push(new FormControl(false));
  //     });
  //     console.log(this.selectedSitesArray.controls)
  //     console.log(this.sites)
  //     console.log(this.activityLogForm.value.sites)
  //   } else{
  //     console.log(this.activityLogForm.value.sites)
  //     while (this.selectedSitesArray.length !== 0) {
  //       this.selectedSitesArray.removeAt(0);
  //     }
  //     console.log(this.activityLogForm.value.sites)
  //     this.sites = this.dummySites;
  //     this.sites.forEach(() =>{
  //     this.selectedSitesArray.push(new FormControl(false));
  //     })
  //     console.log(this.activityLogForm.value.sites)
  //     console.log(this.selectedSitesArray.controls)
  //     console.log(this.sites)
  //   }
  // }

  shiftDateRangeChanged(event){
    this.shiftCreationDate=[];
    if(event.beginEpoc !=0 || event.endEpoc !=0){
    this.shiftCreationDate.push(event);
    }
  }

  logDateRangeChanged(event){
    this.logCreationDate=[];
    if(event.beginEpoc !=0 || event.endEpoc !=0){
    this.logCreationDate.push(event);
    }
  }

  copyMessage(){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = JSON.stringify(this.displayData); 
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  download(){ 
    const element = document.createElement('a') ;
    element.setAttribute(
      'href',
      `data:'text/json ;charset=utf-8,${encodeURIComponent(
        JSON.stringify(this.displayData)
      )}`
    );
    element.setAttribute('download', `Activity-Log-${moment(new Date()).unix()}`);
  
    var event = new MouseEvent('click');
    element.dispatchEvent(event);
  }

  submit(){ 
    let check = this.companies.filter(element => {
    return element._id == this.activityLogForm.controls.company.value ;
   });
   
   const seletedData = this.activityLogForm.value.sites
      .map((checked, i) => (checked ? this.sites[i] : null)).filter((v) => v !== null);
      const siteId = seletedData.map(obj => obj._id);

    let data :any = {
      type:this.activityLogForm.controls.logType.value,
      companyId:check[0]._id,
      shiftStartDate:(this.logCreationDate.length > 0 ? moment(this.logCreationDate[0].beginJsDate).format('YYYY-MM-DD'):''),
      shiftEndDate:(this.logCreationDate.length > 0 ? moment(this.logCreationDate[0].endJsDate).format('YYYY-MM-DD'):'')
    }
    if(this.shiftCreationDate.length > 0 && this.shiftCreationDate && this.activityLogForm.controls.logType.value!='CLEAR_GUARDS_FROM_SHIFTS'){
      data.createdStartDate = moment(this.shiftCreationDate[0].beginJsDate).format('YYYY-MM-DD');
      data.createdEndDate = moment(this.shiftCreationDate[0].endJsDate).format('YYYY-MM-DD');
    }

    if(this.disableSite){
      data.siteIds = siteId
    }
    this.apiService.activityLog(data).subscribe((response:any) => {
      this.showbtn=true
      this.displayData = response;
    },
    (error) => {
       this.toasterService.pop('error', error.error.message);
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/components/activity-log/activity-log.component.ts